import { httpClient } from "../../../lib/http/axios";
import type {
  FeeAdjustmentEditor,
  FeeAdjustmentMemberDetail,
  FeeAdjustmentPreview,
  FeeAdjustmentPreviewCommand,
  FeeAdjustmentRecord,
  CreateFeeAdjustmentRequestCommand,
  UpdateFeeAdjustmentSalesAmountCommand,
} from "../types";

type Envelope<T> = { code: "OK"; message: "success"; data: T };
type ListData = { items: FeeAdjustmentRecord[]; total: number };

/** 公共详情独立读取，不复用列表或编辑器响应。 */
export async function getFeeAdjustmentRecordDetail(workspaceId: string, requestId: string, signal?: AbortSignal): Promise<FeeAdjustmentRecord> {
  const response = await httpClient.get<Envelope<FeeAdjustmentRecord>>(
    `/fee-adjustments/workspaces/${encodeURIComponent(workspaceId)}/records/${encodeURIComponent(requestId)}`,
    { signal },
  );
  return response.data.data;
}

/** 一次取得成员信息与同一报价下的费用记录。 */
export async function getMemberFeeAdjustmentDetail(projectId: string, rosterId: string, memberId: string, customerQuoteId?: string): Promise<FeeAdjustmentMemberDetail> {
  const response = await httpClient.get<Envelope<FeeAdjustmentMemberDetail>>(
    `/fee-adjustments/projects/${encodeURIComponent(projectId)}/rosters/${encodeURIComponent(rosterId)}/members/${encodeURIComponent(memberId)}`,
    customerQuoteId ? { params: { customer_quote_id: customerQuoteId } } : undefined,
  );
  return response.data.data;
}

/**
 *
 */
export async function createFeeAdjustmentRequest(
  rosterId: string,
  command: CreateFeeAdjustmentRequestCommand,
): Promise<FeeAdjustmentRecord> {
  const response = await httpClient.post<Envelope<FeeAdjustmentRecord>>(
    `/fee-adjustments/rosters/${rosterId}/requests`,
    command,
    { "axios-retry": { retries: 0 } },
  );
  return response.data.data;
}

/**
 *
 */
export async function listRosterFeeAdjustmentRequests(
  rosterId: string,
  customerQuoteId?: string,
): Promise<FeeAdjustmentRecord[]> {
  const response = await httpClient.get<Envelope<ListData>>(
    `/fee-adjustments/rosters/${rosterId}/requests`,
    customerQuoteId ? { params: { customer_quote_id: customerQuoteId } } : undefined,
  );
  return response.data.data.items;
}

/**
 *
 */
export async function updateFeeAdjustmentSalesAmount(
  requestId: string,
  command: UpdateFeeAdjustmentSalesAmountCommand,
): Promise<FeeAdjustmentRecord> {
  const response = await httpClient.put<Envelope<FeeAdjustmentRecord>>(
    `/fee-adjustments/requests/${requestId}/sales-amount`,
    command,
    { "axios-retry": { retries: 0 } },
  );
  return response.data.data;
}

/**
 *
 */
export async function listWorkspaceFeeAdjustmentRequests(
  workspaceId: string,
): Promise<FeeAdjustmentRecord[]> {
  const response = await httpClient.get<Envelope<ListData>>(
    `/fee-adjustments/workspaces/${workspaceId}/requests`,
  );
  return response.data.data.items;
}

/**
 *
 */
export async function listWorkspaceFeeAdjustmentRecords(
  workspaceId: string,
): Promise<FeeAdjustmentRecord[]> {
  const response = await httpClient.get<Envelope<ListData>>(
    `/fee-adjustments/workspaces/${workspaceId}/records`,
  );
  return response.data.data.items;
}

/**
 *
 */
export async function getFeeAdjustmentEditor(requestId: string): Promise<FeeAdjustmentEditor> {
  const response = await httpClient.get<Envelope<FeeAdjustmentEditor>>(
    `/fee-adjustments/requests/${requestId}/editor`,
  );
  return response.data.data;
}

/**
 *
 */
export async function previewFeeAdjustment(
  requestId: string,
  command: FeeAdjustmentPreviewCommand,
): Promise<FeeAdjustmentPreview> {
  const response = await httpClient.post<Envelope<FeeAdjustmentPreview>>(
    `/fee-adjustments/requests/${requestId}/preview`,
    command,
    { "axios-retry": { retries: 0 } },
  );
  return response.data.data;
}

/**
 *
 */
export async function completeFeeAdjustment(
  requestId: string,
  command: FeeAdjustmentPreviewCommand & {
    idempotency_key: string;
    processing_basis: string;
  },
): Promise<FeeAdjustmentRecord> {
  const response = await httpClient.post<Envelope<FeeAdjustmentRecord>>(
    `/fee-adjustments/requests/${requestId}/complete`,
    command,
    { "axios-retry": { retries: 0 } },
  );
  return response.data.data;
}
